module.exports = __webpack_public_path__ + "img/page-not-found.ace0eb7f.svg";